import { IProfileMethods, IProfileEntity } from "./interface";
import { profileEntity } from "./entity";

export default <IProfileMethods> {

	setProfile(v: IProfileEntity) {
		profileEntity.profileData = v;
	}

}